




























































































































































import { changeLoading } from '@/util/plugins';
import { Component, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_API, VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  getlist: `${FCAPI}/shang/ruan/contract`,
};
const cooperation_status = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '合作中',
  },
  {
    value: 2,
    label: '合作终止',
  },
];
interface Table<T> {
  limit: number;
  total: number;
  detail: T[];
  current: number;
  last: number;
}
function getData(remote?: Table<any>) {
  remote = (remote || {}) as Table<any>;
  return {
    total: remote.total || 0,
    limit: remote.limit || 1,
    current: remote.current || 1,
    data: remote.detail || [],
    last: remote.last || 1,
    detail: remote.detail || [],
  };
}
interface Form {
  region: string;
  number: string;
  brand_name: string;
  status: number;
}
function initForm() {
  return {
    region: '',
    number: '',
    brand_name: '',
    status: 0,
  };
}
@Component
export default class FinanceContract extends Vue {
  is_loading: boolean = false;
  modal_title: string = '新增品牌';
  show_modal: boolean = false;
  form: Form = initForm();
  product_form: any;
  edit_record: any = {};
  table_data: Table<any> = getData();
  get cooperation_status() {
    return cooperation_status;
  }
  @changeLoading(['is_loading'])
  async search(page: number = 1) {
    const send_data = {
      limit: 50,
      current: page,
      region: this.form.region ? this.form.region : '',
      brand_name: this.form.brand_name ? this.form.brand_name : '',
      number: this.form.number ? this.form.number : '',
      status: this.form.status === 0 ? '' : this.form.status,
    };
    const url = getUrl(API.getlist, send_data);
    const res = await this.$axios.get(url);
    if (res.data.status === 200) {
      this.table_data = getData(res.data.data);
    }
  }
  submit() {
    this.product_form.validateFields(async (err: any, values: any) => {
      if (!err) {
        const send_data = {
          corp_name: values.corp_name,
          region: values.region,
          brand_name: values.brand_name,
          number: values.number,
          status: values.status,
          joint_mobile: values.joint_mobile,
          joint_name: values.joint_name,
        };
        if (this.modal_title === '新增品牌') {
          const res = await this.$axios.post(API.getlist, send_data);
          if (res.data.status === 200) {
            this.show_modal = false;
            this.$message.success('新增成功');
            this.search(this.table_data.current);
          } else {
            this.$message.error(res.data.message);
          }
        } else {
          const res = await this.$axios.put(`${API.getlist}/${this.edit_record.id}`, send_data);
          if (res.data.status === 200) {
            this.show_modal = false;
            this.$message.success('编辑成功');
            this.search(1);
          } else {
            this.$message.error(res.data.message);
          }
        }
      } else {
        this.$message.error('请填入必填项');
      }
    });
  }
  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }
  clearForm() {
    this.form = initForm();
  }
  changePage(page: any) {
    this.search(page.current);
  }
  add() {
    this.modal_title = '新增品牌';
    this.show_modal = true;
    this.product_form.resetFields();
  }
  edit(record: any) {
    this.modal_title = '编辑品牌';
    this.edit_record = record;
    this.show_modal = true;
    this.$nextTick(() => {
      this.product_form.setFieldsValue({
        corp_name: record.corp_name,
        region: record.region,
        brand_name: record.brand_name,
        number: record.number,
        status: record.status,
        joint_mobile: record.joint_mobile,
        joint_name: record.joint_name,
      });
    });
  }
  beforeCreate() {
    this.product_form = this.$form.createForm(this);
  }
  created() {
    this.search(1);
  }
}
